import Repository from './Repository'

const endpoint = 'customerEndpoint'

const token = '8c7c8876451374b1978bcbd8167e427e'
const tokenIdWebSafe = 'ahZzfnN0dW5uaW5nLWJhc2UtMTY0NDAycl4LEgVDVXNlciIkZTc2MGUxYmMtMDBlMi00ZGU2LWEwZGYtNDk5OGNiOGEzNDBjDAsSBVRva2VuIiRmODlhNjUwMi05MmJjLTRiYWEtODlhNi1hMGU2MjEwYjY0ZWEM'

export default {
  get() {
    return Repository.backend.get(`${endpoint}/getPrivacyInfo`, { params: { token, tokenIdWebSafe } })
  },
}
